module.exports = __webpack_public_path__ + "static/media/profile_placeholder_2.8c32e871.svg";